module.exports = __webpack_public_path__ + "img/casita.09c18052.svg";